class CustomSelect extends HTMLElement {
  constructor() {
    super();

    const textInput = document.querySelectorAll(".currency-search-input");
    const selectorButton = this.querySelector(".custom-select__toggle");
    const selectorListItem = this.querySelector(".custom-select__options");
    const selectorListValue = this.querySelector(".variant-options__option");
    const valueHiddenInput = document.querySelector(".js-hidden-input");
    const currencyForm = document.querySelector(".js-currency-form");
    const chevron = this.querySelector(".open-close-chevron");
    const currencyFormOverview = document.querySelector(".currency-form");
    const closeCurrencyForm = document.querySelectorAll(".close-button");

    closeCurrencyForm.forEach((element) => {
      element.addEventListener("click", () => {
        selectorListItem.classList.remove("custom-select__options--open");
        chevron.classList.remove("open-close-chevron--open");
      });
    });

    textInput.forEach((element) => {
      element.addEventListener("focus", () => {
        selectorListItem.classList.add("custom-select__options--open");
        chevron.classList.add("open-close-chevron--open");
      });
    });

    selectorListValue.addEventListener("change", (e) => {
      valueHiddenInput.value = e.target.value;
      currencyFormOverview.classList.remove("currency-form--js-active");
    });

    selectorButton.addEventListener("click", () => {
      selectorListItem.classList.toggle("custom-select__options--open");
      chevron.classList.toggle("open-close-chevron--open");
    });
  }
}

// Check if element is defined, if not define it..
// eslint-disable-next-line no-undefined
if (customElements.get("custom-select") === undefined) {
  customElements.define("custom-select", CustomSelect);
}
